import http from 'common-module/src/util/http';

export async function addPin(data) {
  return http.post('/sys-pin/issue/add-pin', data);
}

export async function getPinList(data) {
  return http.post('/sys-pin/page-list', data, { showError: false });
}

export async function cancelPin(data) {
  return http.post('/sys-pin/issue/remove-pin', data);
}

export async function removeAllPin(data = {}) {
  return http.post('/sys-pin/remove-all-pin', data);
}
